import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, generateUUID, isFunction, isUndefined } from '@philips-internal/oswald-ui-utils';
import { ToastService } from '../../services/toast-service/toast-service.js';
import { ToastNotification } from '../toast-notification/toast-notification.js';
import './toast-manager.css';
class ToastManager extends Component {
    constructor() {
        super(...arguments);
        this.toasts = new Map();
        this.listeners = [];
        this.onToastClose = (id, skipEvent = false) => {
            const item = this.toasts.get(id);
            if (!item) {
                return;
            }
            const { container, root, toast } = item;
            if (!container) {
                return;
            }
            if (!skipEvent && isFunction(toast.onClose)) {
                toast.onClose(new CloseEvent());
            }
            root.unmount();
            container.remove();
            this.toasts.delete(id);
        };
        this.closeAllToasts = () => {
            for (const [id] of this.toasts) {
                this.onToastClose(id, true);
            }
        };
        this.closeToast = (id) => {
            this.closeToast(id);
        };
        this.openToast = (toast) => {
            const { id = generateUUID() } = toast;
            if (this.toasts.has(id)) {
                return;
            }
            const container = this.createToastContainer(toast);
            const toastElement = this.createToast(id, toast);
            const root = createRoot(container);
            this.toasts.set(id, {
                container,
                root,
                toast,
            });
            root.render(toastElement);
        };
    }
    componentDidMount() {
        this.listeners.push(AuthenticationService.listenLogout(() => this.closeAllToasts()), ToastService.addCloseAllListener(() => this.closeAllToasts()), ToastService.addCloseListener((id) => this.onToastClose(id)), ToastService.addListener((toast) => this.openToast(toast)));
        this.containerBottom = this.createBaseContainer(Placement.BOTTOM);
        this.containerTop = this.createBaseContainer(Placement.TOP);
    }
    componentWillUnmount() {
        this.listeners.forEach((listener) => listener());
        this.closeAllToasts();
        if (this.containerBottom) {
            this.containerBottom.remove();
        }
        if (this.containerTop) {
            this.containerTop.remove();
        }
    }
    applyOffset(element, offset, placement) {
        element.style[placement] = `${offset}px`;
    }
    createBaseContainer(placement) {
        const element = document.createElement('div');
        element.className = classNames({
            'c-toast-manager__base-container': true,
            [`c-toast-manager__base-container--${placement}`]: true,
        });
        document.body.append(element);
        return element;
    }
    createToastContainer(toast) {
        const { offset, placement = Placement.BOTTOM, type } = toast;
        const element = document.createElement('div');
        const container = placement === Placement.BOTTOM
            ? this.containerBottom
            : this.containerTop;
        container.append(element);
        if (container && !isUndefined(offset) && offset != 0) {
            this.applyOffset(container, offset, placement);
        }
        element.className = classNames({
            'c-toast-manager__container': true,
            [`c-toast-manager__container--${type}`]: Boolean(type),
        });
        return element;
    }
    createToast(id, toast) {
        const { action, ...otherProps } = toast;
        return (React.createElement(ToastNotification, { onClose: () => this.onToastClose(id), uuid: id, ...otherProps }, action));
    }
    render() {
        return null;
    }
}
export default ToastManager;
//# sourceMappingURL=toast-manager.js.map